<template>
  <div>
    <button class="menu">
      <div class="neon">
        <span class="middle"></span>
        <span class="core"></span>
      </div>

      <!-- Norican for "X" -->
    </button>
  </div>
</template>

<script>
export default {
  name: "Menu",
  data() {
    return {
      open: false
    };
  }
};
</script>

<style lang="scss">
button.menu {
  position: fixed;
  top: 48px;
  right: 48px;
  height: 48px;
  width: 48px;

  > .neon {
    position: relative;
    height: 18px;
    width: 32px;
    margin: auto;

    &::before,
    > .middle,
    &::after {
      content: "";
      position: absolute;
      height: 2px;
      width: 32px;
      background: #fff;
      border-radius: 99px;
      box-shadow: $shadow-neon-small2;
    }

    &::before {
      top: 0;
      left: 0;
      z-index: 100;
    }

    > .middle {
      top: 50%;
      left: 0;
      width: 24px;
      z-index: 102;
    }

    &::after {
      bottom: 0;
      left: 0;
      width: 28px;
      z-index: 101;
    }

    > .core {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      width: 0px;
      height: 0px;
      box-shadow: $shadow-neon-small;
    }
  }
}
</style>
